$(document).ready(function() {
    // First define the callback
    window.initGoogleMaps = function() {
        console.log('Google Maps loaded, initializing...');
        initializeGoogleMaps();
    };

    // Then load Google Maps
    var script = document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBGVZSTKYslQqIJ-CZ6dxjxoBdvPAz5qI8&callback=initGoogleMaps';
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
});

$( document ).ready(function() {

	AOS.init();
    fitvid();
    revealed_menu_submenus();
    gallery_module();
    retreats_slider_module();
    chalet_slider_module();
    google_review_slider_module();
    chalet_testimonials_slider_module();
    vertical_season_image_module();

    // Fix slider accessibility after initialization
    setTimeout(function() {
        fixTnsAccessibility();
        initTnsAccessibilityObserver();
    }, 500);

    popup_gallery();
    on_hover();
    watch_sleeps();
    submit_availability_search();
    reveal_enquiry();
    // chalet_filters();
    // open_modal();
    // fullscreen_slider();
    goto_retreats_form();
    burger_trigger();
    offers_trigger();
    iframe_popup();
    chalet_description_reveal();
    reveal_expanding_retreats();

    $('.search-sleeps').select2({
        minimumResultsForSearch: -1
    });

    

    
   $('.image-lightbox').magnificPopup({type:'image'});

   chalet_price_terms();

});

back_to_top();
fix_header_on_scroll();

function reveal_expanding_retreats()
{    
        $('.expanding-retreats__module .reveal-retreat').on( "click", function(e) {
           e.preventDefault();
           console.log('.expanded ' + $(this).data('season'));
           $('.ctas .' + $(this).data('season')).hide();
           $('.ctas .season').removeClass('col-lg-6');
           $('.expanded .' + $(this).data('season') ).show();
            
            $([document.documentElement, document.body]).animate({
                scrollTop: $('.expanded .' + $(this).data('season')).offset().top -100
            }, 0);

        });
}
    

function goto_retreats_form()
{    
        $('.goto-retreats-form').on( "click", function(e) {
           e.preventDefault();
            $([document.documentElement, document.body]).animate({
                scrollTop: $('.retreats-form__module').offset().top -100
            }, 0);
        });    
}


function reveal_enquiry()
{
    $(".reveal-enquiry").on( "click", function(e){
        e.preventDefault();
        $(".reveal-enquiry__module").show();
        $('html, body').animate({
            scrollTop: $(".reveal-enquiry__module").offset().top -250
        }, 1000);        
    });       
}


function submit_availability_search()
{
    $start_date = $('.search-start_date').val();
    $sleeps = $('.search-sleeps').val();

    if($start_date && $sleeps)
    {
        document.getElementById('automated-search-dates').submit();
    }
}


function watch_sleeps()
{
    $('.automated.search-dates__module .search-sleeps').on('change', function() {
        submit_availability_search();
    });    
}


function chalet_price_terms()
{
    hide_show_extras_and_pricing('.nav-link.active');


    $(".availability-pricing__module .nav-link").on( "click", function(){
        hide_show_extras_and_pricing($(this));
    });    
}
function hide_show_extras_and_pricing($name) 
{
    $season_catered_type = $($name).attr( "data-price-terms" );
    $season_type = $($name).attr( "data-season" );
    
    $('.pricing-terms__module .catered, .pricing-terms__module .self-catered').hide();
    $('.pricing-terms__module .'+$season_catered_type).show();

    $('.extras-available__module .extra').hide();
    $('.extras-available__module .'+$season_type+'-'+$season_catered_type).show();    
}


function chalet_description_reveal() 
{
    $( ".chalet-description__module .show-description" ).on( "click", function(e) {
      e.preventDefault();
      $(this).fadeOut();
      $(".chalet-description__module .revealed-description").show("slow");
    });
}

function iframe_popup()
{
  $('.iframe-popup').magnificPopup({type:'iframe'});
}


function revealed_menu_submenus()
{
      $(".revealed-menu__module .sub-menu").each(function() {
            $parent_link = $(this).prev();
            $parent_link.addClass('sub-menu-parent').attr("href", "#");
            $($parent_link).on( "click", function() {
              $(this).next('.sub-menu').slideToggle();
            });            
      });
}

function burger_trigger() {
    $('.mega-menu-trigger .mega-menu-burger').on( "click", function() {
      console.log('burger nom nom...');
      $(this).toggleClass('is-active');
      var isExpanded = $(this).hasClass('is-active');
      $(this).attr('aria-expanded', isExpanded);
      $('.main.mega-menu').slideToggle();
      $("html, body").scrollTop(0);
    });
}

function offers_trigger() {
    $('.offers-trigger').on( "click", function() {
      $('.expanded-offers').toggleClass('is-active');
      $('.expanded-offers').slideToggle();
// var $container = $("html,body");
// var $scrollTo = $('.offers');
// $container.animate({scrollTop: $scrollTo.offset().top - $container.offset().top + $container.scrollTop()-200, scrollLeft: 0},300);       
    });
}

// Fix accessibility for Tiny Slider - prevent focus on hidden slides
function fixTnsAccessibility() {
    // Focusable elements selector
    var focusable = 'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"]), iframe';

    // Set tabindex=-1 on focusable elements in hidden slides
    $('.tns-item[aria-hidden="true"]').find(focusable).attr('tabindex', '-1');
    // Remove tabindex restriction on visible slides
    $('.tns-item:not([aria-hidden="true"])').find(focusable).each(function() {
        if ($(this).data('original-tabindex') !== undefined) {
            $(this).attr('tabindex', $(this).data('original-tabindex'));
        } else {
            $(this).removeAttr('tabindex');
        }
    });
}

// Run fix after any slider transition and on attribute changes
$(document).on('transitionend webkitTransitionEnd', '.tns-item', function() {
    fixTnsAccessibility();
});

// Observe aria-hidden attribute changes on slider items
function initTnsAccessibilityObserver() {
    if (typeof MutationObserver !== 'undefined') {
        var observer = new MutationObserver(function(mutations) {
            fixTnsAccessibility();
        });

        $('.tns-item').each(function() {
            observer.observe(this, { attributes: true, attributeFilter: ['aria-hidden'] });
        });
    }
}

function chalet_testimonials_slider_module() {
  if ($(".chalet-testimonials__module  .slider-testimonials").length > 0) {
    
    $controls_id = '#controls-testimonials';
    
    const tnsCarousel = document.querySelectorAll('.chalet-testimonials__module  .slider-testimonials');
    tnsCarousel.forEach(slider => {
          const tnsSlider = tns({
                  container: slider,
                  controlsContainer: $controls_id,                  
                  autoplayHoverPause: true,
                  speed: 500,
                  mouseDrag: false,
                  autoHeight: false,
                  center: true,
                  loop: true,
                  gutter: 0,
                  items: 1,
                  controls: true,
                  nav: false,
                  autoplayButtonOutput: false,
                  autoplay: false,
                  autoplayTimeout: 10000,
          });
    });

  }
}




function retreats_slider_module() {
  if ($(".retreats-slider__module .slider-retreats").length > 0) {
    
    $controls_id = '#controls-retreats';
    
    const tnsCarousel = document.querySelectorAll('.retreats-slider__module .slider-retreats');
    tnsCarousel.forEach(slider => {
          const tnsSlider = tns({
                  container: slider,
                  controlsContainer: $controls_id,                  
                  autoplayHoverPause: true,
                  speed: 500,
                  mouseDrag: false,
                  autoHeight: false,
                  center: true,
                  loop: true,
                  gutter: 0,
                  items: 1,
                  controls: true,
                  nav: false,
                  autoplayButtonOutput: false,
                  autoplay: false,
                  autoplayTimeout: 10000,
          });
    });

  }
}
function chalet_slider_module() {
  if ($(".chalet-slider__module .slider-chalet").length > 0) {

    let sliders = document.querySelectorAll('.chalet-slider__module .slider-chalet');
    let controls = document.querySelectorAll('.controls-chalet');
    let previous = document.querySelectorAll('.controls-chalet .prev');
    let next = document.querySelectorAll('.controls-chalet .next');

    for (let i = 0; i < sliders.length; i++) {
      tns({
        container: sliders[i],
        controlsContainer: controls[i],
        prevButton: previous[i],
        nextButton: next[i],
        autoplayHoverPause: true,
        speed: 500,
        mouseDrag: false,
        autoHeight: false,
        center: false,
        loop: true,
        gutter: 30,
        items: 1,
        controls: true,
        nav: false,
        autoplayButtonOutput: false,
        autoplay: false,
        autoplayTimeout: 10000,
        responsive: {
          1200: {
            items: 2,
            gutter: 30
          }
        }
      });
    }
  }
}
function google_review_slider_module() {
    if ($(".google-review-result__module .review-slider").length > 0) {
        let sliders = document.querySelectorAll('.google-review-result__module .review-slider');
        let controls = document.querySelectorAll('.controls-review');
        let previous = document.querySelectorAll('.controls-review .prev');
        let next = document.querySelectorAll('.controls-review .next');

        for (let i = 0; i < sliders.length; i++) {
            tns({
                container: sliders[i],
                controlsContainer: controls[i],
                prevButton: previous[i],
                nextButton: next[i],
                items: 1,
                slideBy: 'page',
                autoplayHoverPause: true,
                speed: 500,
                mouseDrag: true,
                autoHeight: false,
                center: true,
                loop: true,
                gutter: 0,
                controls: true,
                nav: false,
                autoplayButtonOutput: false,
                autoplay: false,
                autoplayTimeout: 10000,
                responsive: {
                    1200: {
                        disable: true
                    }
                }
            });
        }
    }
}




function vertical_season_image_module() {
  if ($(".vertical-season-image__module .slider").length > 0) {

    const tnsCarousel = document.querySelectorAll('.vertical-season-image__module .slider');
    tnsCarousel.forEach(slider => {
          const tnsSlider = tns({
                  container: slider,
                  autoplay: true,
                  mouseDrag: false,
                  autoHeight: false,
                  gutter: 0,
                  mode: "gallery",
                  items: 1,
                  controls: false,
                  nav: false,
                  autoplayButtonOutput: false,
          });
    });

  }
}



function gallery_module() {
  if ($(".gallery__module .gallery").length > 0) {

    const tnsCarousel = document.querySelectorAll('.gallery__module .gallery');
    tnsCarousel.forEach(slider => {
          const tnsSlider = tns({
                  container: slider,
                  autoplay: true,
                  mouseDrag: false,
                  autoHeight: false,
                  gutter: 0,
                  speed: 1000,
                  items: 1,
                  mode: "gallery",
                  controls: false,
                  nav: false,
                  autoplayButtonOutput: false,
          });
    });

  }
}

function back_to_top() {
    $('.back-to-top__module').on('click', function (e) {
        e.preventDefault();
        $('html,body').animate({
            scrollTop: 0
        }, 700);
    });
    $(window).scroll(function() {
        if ($(window).scrollTop() >= 100) {
            $("body").addClass("scrolling");
            $('.back-to-top__module').addClass('visible');
        } else {
            $("body").removeClass("scrolling");
            $('.back-to-top__module').removeClass('visible');
        }
    });
}


function fitvid() {
	$(".fit-vid").fitVids();
    $('iframe[src*="youtube"]').parent().fitVids();
}





function on_hover() {
    $('.hover-state').hover(
        function(){ $(this).addClass('hovering') },
        function(){ $(this).removeClass('hovering') }
    )
}




function fix_header_on_scroll() {

    // if ($('html').hasClass("home")) {
    //     $(".top-bar__module").addClass("fixed-header");
    // }
    // else {

    $(window).on("load", function() {


            if ($(window).scrollTop() > 265) {

                var breakpoint = window.matchMedia("screen and (min-width:1200px)").matches;
                if ( breakpoint ) {
                    $(".top-bar__module").addClass("fixed-header animated slideInDown");
                    $(".top-bar-fixed-spacer").show();
                }

            } else {
                $(".top-bar__module").removeClass("fixed-header animated slideInDown");
                $(".top-bar-fixed-spacer").hide();
            }

        });
        $(window).scroll(function() {
            if ($(window).scrollTop() >= 265) {

                var breakpoint = window.matchMedia("screen and (min-width:1200px)").matches;
                if ( breakpoint ) {
                    $('.top-bar__module').addClass('fixed-header animated slideInDown');
                    $(".top-bar-fixed-spacer").show();
                }

            } else {
                $('.top-bar__module').removeClass('fixed-header animated slideInDown');
                $(".top-bar-fixed-spacer").hide();
            }
        });
    }
    // }


    function open_modal() {
        $('.open-modal').magnificPopup({
          type:'inline',
          midClick: true
        });
    }

    function popup_gallery() {
      if ($(".popup-gallery").length > 0) {
          $('.popup-gallery').each(function () {
              $(this).magnificPopup({
                  delegate: 'a',
                  type: 'image',
                  tLoading: 'Loading image #%curr%...',
                  mainClass: 'mfp-img-mobile',
                  gallery: {
                      enabled: true,
                      navigateByImgClick: true,
                      preload: [0, 1]
                  },
                    image: {
                      markup:   '<div class="mfp-figure">'+
                                    '<div class="mfp-close"></div>'+
                                    '<div class="mfp-img"></div>'+
                                    '<div class="mfp-bottom-bar">'+
                                     '<div class="mfp-title"></div>'+
                                     '</div>'+
                              '</div>',
                      cursor: 'mfp-zoom-out-cur',
                      verticalFit: true,
                        titleSrc: function(item) {
                            return item.el.attr('title');
                          },
                      tError: '<a href="%url%">The image</a> could not be loaded.'
                    }
              });
          });



  }
}



function fullscreen_slider() {

  $controls_id = '.controls-fullscreen-slider';
  $container_class = '.slider-fullscreen-slider';
  $slider_class = '.slider-fullscreen-slider';
  $slider_name = 'slider_fullscreen-slider';

     if ( $($slider_class).length > 0) {
        var $slider_name = tns({
        container: $container_class,
        controls: true,
        controlsContainer: $controls_id,
        items: 1,
        nav: false,
        slideBy: 1,
        center: true,
        mouseDrag: false,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayHoverPause: true,
        autoplayTimeout: 3000,
        loop: true,
        mode: 'gallery',
        speed: 3000,
        touch: true,
        preventActionWhenRunning: false,
        // preventScrollOnTouch: "auto",
        gutter: 0,
        swipeAngle: false
        });
      }


}

    function fbShare(url, title, descr, image, winWidth, winHeight) {
        var winTop = (screen.height / 2) - (winHeight / 2);
        var winLeft = (screen.width / 2) - (winWidth / 2);
        window.open('http://www.facebook.com/sharer.php?s=100&p[title]=' + title + '&p[summary]=' + descr + '&p[url]=' + url + '&p[images][0]=' + image, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
    }

    function googleShare(url, winWidth, winHeight) {
        window.open("https://plus.google.com/share?url=" + url + "", "", "width=" + winWidth + ", height=" + winHeight + "");
    }


    // Immediately define the global callback to prevent timing issues
window.initGoogleMaps = function() {
    console.log('Google Maps callback triggered');

    // Check if jQuery is loaded
    if (typeof jQuery === 'undefined') {
        console.error('jQuery not loaded yet, retrying...');
        setTimeout(window.initGoogleMaps, 100);
        return;
    }

    // Check if our map initialization is ready
    if (typeof window.initializeGoogleMaps === 'function') {
        window.initializeGoogleMaps();
    } else {
        console.log('Map initialization not ready, waiting...');
        setTimeout(window.initGoogleMaps, 100);
    }
};

// Main application code
(function($) {
    'use strict';

    // Store references at window level for debugging
    window.mapInstances = [];

    // Define the actual initialization function
    window.initializeGoogleMaps = function() {
        console.log('Initializing Google Maps...');

        // Ensure DOM is ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initializeGoogleMaps);
            return;
        }

        map_size();

        if ($('.template-map-page').length) {
            console.log('Initializing map on template page');
            var map = initMap($('.map'));
            if (map) window.mapInstances.push(map);
        } else {
            console.log('Initializing map on regular page');
            $('.map__module .map').each(function() {
                var map = initMap($(this));
                if (map) window.mapInstances.push(map);
            });
        }
    };

    // Map sizing function
    function map_size() {
        function setMapHeight() {
            $('.map').each(function() {
                var $map = $(this);
                var $module = $map.closest('.map__module');
                if ($module.length) {
                    var height = $module.height();
                    $map.css('height', height + 100);
                }
            });
        }

        // Set initial height
        setMapHeight();

        // Update on window resize with debouncing
        var resizeTimer;
        $(window).on('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(setMapHeight, 250);
        });
    }

    /**
     * initMap
     *
     * Renders a Google Map onto the selected jQuery element with filtering capabilities
     * and includes bus routes data and ski area polygons
     *
     * @param   jQuery $el The jQuery element.
     * @return  object The map instance.
     */
    function initMap($el) {
        // Validate element
        if (!$el || !$el.length) {
            console.error('Invalid map element');
            return null;
        }

        // Ensure element has dimensions
        if ($el.width() === 0 || $el.height() === 0) {
            console.warn('Map element has no dimensions, setting defaults');
            $el.css({
                width: '100%',
                height: '400px'
            });
        }

        // Check if Google Maps is loaded
        if (typeof google === 'undefined' || !google.maps) {
            console.error('Google Maps API not loaded');
            return null;
        }

        // Store active filter categories
        var activeFilters = {
            chalets: true,
            ski_lift: false,
            bus_stop: false,
            bar: false,
            restaurant: false,
            other: false,
            bus_routes: false,
            ski_area: false
        };

        // Bus route lines and their colors
        var busRoutes = [];

        // Ski area polygons
        var skiAreaPolygons = [];

        // Read inline .marker elements BEFORE map init (Google Maps clears innerHTML)
        var inlineMarkers = [];
        $el.find('.marker').each(function() {
            var $marker = $(this);
            var lat = $marker.data('lat');
            var lng = $marker.data('lng');
            var content = $marker.html();
            if (lat && lng) {
                inlineMarkers.push({lat: parseFloat(lat), lng: parseFloat(lng), content: content});
            }
        });

        // Create generic map
        var mapArgs = {
            zoom: $el.data('zoom') || 14,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            center: {lat: 46.0678, lng: 6.6413} // Default center (Morzine)
        };

        try {
            var map = new google.maps.Map($el[0], mapArgs);
        } catch (error) {
            console.error('Failed to create map:', error);
            return null;
        }

        // Initialize markers array
        map.markers = [];

        // Check if chaletData is defined and not empty
        if (typeof chaletData !== 'undefined' && chaletData && chaletData.length) {
            console.log('Loading chalets:', chaletData.length);
            chaletData.forEach(function(chalet) {
                try {
                    initChaletMarker(chalet, map, chaletData.length);
                } catch (e) {
                    console.error('Error loading chalet marker:', e);
                }
            });
        } else {
            console.log('No chalet data available');
        }

        // Check if markerData is defined and not empty
        if (typeof markerData !== 'undefined' && markerData && markerData.length) {
            console.log('Loading markers:', markerData.length);
            markerData.forEach(function(marker) {
                try {
                    initCustomMarker(marker, map);
                } catch (e) {
                    console.error('Error loading custom marker:', e);
                }
            });
        } else {
            console.log('No marker data available');
        }

        // Add inline markers (read before map init)
        if (inlineMarkers.length) {
            console.log('Loading inline markers:', inlineMarkers.length);
            inlineMarkers.forEach(function(markerData) {
                var marker = new google.maps.Marker({
                    position: {lat: markerData.lat, lng: markerData.lng},
                    map: map
                });

                // Create info window if marker has content
                if (markerData.content) {
                    var infoWindow = new google.maps.InfoWindow({
                        content: markerData.content
                    });

                    google.maps.event.addListener(marker, 'click', function() {
                        infoWindow.open(map, marker);
                    });

                    marker.infoWindow = infoWindow;
                }

                map.markers.push(marker);
            });
        }

        // Load bus routes data from the JSON file
        loadBusRoutes(map);

        // Load ski area data from CSV
        if (typeof skiAreaData !== 'undefined' && skiAreaData && skiAreaData.length) {
            console.log('Loading ski areas:', skiAreaData.length);
            loadSkiArea(skiAreaData, map);
        } else {
            console.log('No ski area data available');
        }

        // Center map based on markers (with delay to ensure all markers are loaded)
        setTimeout(function() {
            centerMap(map);
        }, 500);

        // Apply initial visibility to all markers based on activeFilters
        map.markers.forEach(function(marker) {
            if (marker.category && !activeFilters[marker.category]) {
                marker.setVisible(false);
            }
        });

        // Apply initial visibility to bus routes
        busRoutes.forEach(function(route) {
            route.setVisible(activeFilters.bus_routes);
        });

        // Apply initial visibility to ski areas
        skiAreaPolygons.forEach(function(polygon) {
            polygon.setVisible(activeFilters.ski_area);
        });

        // Hide filter buttons for categories with no data
        var categoryCounts = {
            chalets: 0,
            ski_lift: 0,
            bus_stop: 0,
            bar: 0,
            restaurant: 0,
            other: 0
        };

        // Count markers by category
        map.markers.forEach(function(marker) {
            if (marker.category && categoryCounts.hasOwnProperty(marker.category)) {
                categoryCounts[marker.category]++;
            }
        });

        // Hide buttons for empty categories
        Object.keys(categoryCounts).forEach(function(category) {
            if (categoryCounts[category] === 0) {
                $('.filter-option[data-category="' + category + '"]').hide();
            }
        });

        // Special case for bus routes
        $('.filter-option[data-category="bus_routes"]').show();

        // Special case for ski areas
        $('.filter-option[data-category="ski_area"]').show();

        // Set up filter functionality
        $(document).off('click', '.map-filter-controls .filter-option');
        $(document).on('click', '.map-filter-controls .filter-option', function() {
            var category = $(this).data('category');

            // Toggle active class
            $(this).toggleClass('active');

            // Update filter state
            activeFilters[category] = !activeFilters[category];

            // Apply filters to markers
            map.markers.forEach(function(marker) {
                if (marker.category && activeFilters[marker.category]) {
                    marker.setVisible(true);
                } else if (marker.category && !activeFilters[marker.category]) {
                    marker.setVisible(false);
                }
            });

            // Apply filter to bus routes
            if (category === 'bus_routes') {
                busRoutes.forEach(function(route) {
                    route.setVisible(activeFilters.bus_routes);
                });
            }

            // Apply filter to ski areas
            if (category === 'ski_area') {
                skiAreaPolygons.forEach(function(polygon) {
                    polygon.setVisible(activeFilters.ski_area);
                });
            }
        });

        // Return map instance
        return map;

        /**
         * Load Bus Routes from JSON file and display on map
         */
        function loadBusRoutes(map) {
            $.ajax({
                url: '/wp-content/themes/alikats/assets/js/bus-routes.json',
                dataType: 'json',
                success: function(data) {
                    console.log('Bus routes data loaded successfully');
                    if (data && data.Placemark) {
                        // Process bus routes
                        processBusRoutes(data, map);
                    }
                },
                error: function(xhr, status, error) {
                    console.error('Error loading bus routes data:', error);
                }
            });
        }

        /**
         * Load Ski Area from CSV data and display on map
         */
        function loadSkiArea(skiAreaData, map) {
            console.log('Processing ski area data');

            // Define colors for different ski areas
            var skiAreaColors = {
                'morzine-les-gets': '#E9D1C4',
                'avoriaz': '#E9D1C4',
                'chatel': '#E9D1C4',
                'swiss': '#E9D1C4',
                'st-jean-d\'aulps': '#E9D1C4',
                'mt-chery-les-gets': '#E9D1C4'
            };

            // Process each ski area from the data
            skiAreaData.forEach(function(area) {
                if (!area.wkt) {
                    console.error('Ski area missing WKT data:', area);
                    return;
                }

                try {
                    // Parse the WKT polygon string into an array of coordinates
                    var coordinates = parseWKTPolygon(area.wkt);

                    if (coordinates.length === 0) {
                        console.error('Failed to parse WKT data for:', area.name);
                        return;
                    }

                    // Get color for this ski area, or use a default
                    var fillColor = skiAreaColors[area.name] || '#FF9800';

                    // Create the polygon
                    var polygon = new google.maps.Polygon({
                        paths: coordinates,
                        strokeColor: fillColor,
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: fillColor,
                        fillOpacity: 0.35,
                        map: map,
                        visible: activeFilters.ski_area
                    });

                    // Add click event for info window
                    google.maps.event.addListener(polygon, 'click', function(event) {
                        var infoWindow = new google.maps.InfoWindow({
                            content: '<div class="map-infowindow ski-area-infowindow">' +
                                    '<h4>' + formatSkiAreaName(area.name) + '</h4>' +
                                    '</div>'
                        });
                        infoWindow.setPosition(event.latLng);
                        infoWindow.open(map);
                    });

                    // Add to ski area polygons array
                    skiAreaPolygons.push(polygon);

                } catch (error) {
                    console.error('Error creating ski area polygon:', error);
                }
            });
        }

        /**
         * Format ski area name for display (capitalize, replace hyphens)
         */
        function formatSkiAreaName(name) {
            return name.split('-').map(function(word) {
                return word.charAt(0).toUpperCase() + word.slice(1);
            }).join(' ').replace('D\'aulps', 'd\'Aulps');
        }

        /**
         * Parse WKT Polygon format into Google Maps coordinates
         */
        function parseWKTPolygon(wktString) {
            var coordinates = [];

            // Extract coordinates from WKT POLYGON format
            // Example: "POLYGON ((lon1 lat1, lon2 lat2, ...))"
            var match = wktString.match(/\(\((.*?)\)\)/);

            if (match && match[1]) {
                // Split the coordinate pairs
                var coordPairs = match[1].split(',');

                // Parse each coordinate pair
                coordPairs.forEach(function(pair) {
                    var parts = pair.trim().split(' ');
                    if (parts.length >= 2) {
                        var lng = parseFloat(parts[0]);
                        var lat = parseFloat(parts[1]);

                        if (!isNaN(lng) && !isNaN(lat)) {
                            coordinates.push({
                                lat: lat,
                                lng: lng
                            });
                        }
                    }
                });
            }

            return coordinates;
        }

        /**
         * Process bus routes data and add to map
         */
        function processBusRoutes(data, map) {
            if (!data.Placemark || !data.Placemark.length) {
                return;
            }

            // Process each route line
            data.Placemark.forEach(function(placemark, index) {
                if (placemark.LineString && placemark.LineString.coordinates) {
                    var coordinates = parseBusRouteCoordinates(placemark.LineString.coordinates);
                    if (coordinates.length > 0) {
                        // Create the polyline for the bus route
                        var routePath = new google.maps.Polyline({
                            path: coordinates,
                            geodesic: true,
                            strokeColor: '#b28369',
                            strokeOpacity: 0.8,
                            strokeWeight: 4,
                            map: map,
                            visible: activeFilters.bus_routes
                        });

                        // Store route name for info window
                        routePath.routeName = placemark.name || 'Bus Route ' + (index + 1);

                        // Add to bus routes array
                        busRoutes.push(routePath);
                    }
                }
            });
        }

        /**
         * Parse bus route coordinates string into array of LatLng
         */
        function parseBusRouteCoordinates(coordinatesStr) {
            // Clean and split the coordinates string
            var cleanedStr = coordinatesStr.trim().replace(/\n/g, ' ').replace(/\s+/g, ' ');
            var coordPairs = cleanedStr.split(' ');
            var coordinates = [];

            // Parse each coordinate pair
            coordPairs.forEach(function(pair) {
                var parts = pair.split(',');
                if (parts.length >= 2) {
                    var lng = parseFloat(parts[0]);
                    var lat = parseFloat(parts[1]);
                    if (!isNaN(lng) && !isNaN(lat)) {
                        coordinates.push({
                            lat: lat,
                            lng: lng
                        });
                    }
                }
            });

            return coordinates;
        }

        /**
         * Initialize chalet marker
         */
        function initChaletMarker(chalet, map, totalChalets) {
            // Validate data
            if (!chalet.lat || !chalet.lng) {
                console.error('Invalid chalet coordinates:', chalet);
                return null;
            }

            // SVG icon for chalets
            var chaletIcon = {
                url: '/wp-content/themes/alikats/assets/images/marker/chalet.svg',
                scaledSize: new google.maps.Size(50, 35),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(25, 35)
            };

            // Create marker instance
            var marker = new google.maps.Marker({
                position: {
                    lat: parseFloat(chalet.lat),
                    lng: parseFloat(chalet.lng)
                },
                map: map,
                icon: chaletIcon,
                title: chalet.title || 'Chalet',
                category: 'chalets'
            });

            var infoWindowContent = '<div class="map-infowindow chalet-infowindow">' +
                '<h4><a href="' + chalet.url + '">' + (chalet.title || 'Chalet') + '</h4></a>' +
                '<p>' + (chalet.description || '') + '</p>';


            infoWindowContent += '</div>';

            // Create info window
            var infoWindow = new google.maps.InfoWindow({
                content: infoWindowContent
            });

            // Show info window when marker is clicked
            google.maps.event.addListener(marker, 'click', function() {
                // Close all open info windows first
                map.markers.forEach(function(m) {
                    if (m.infoWindow) {
                        m.infoWindow.close();
                    }
                });

                infoWindow.open(map, marker);
            });

            // Store infoWindow reference
            marker.infoWindow = infoWindow;

            // Append to reference for later use
            map.markers.push(marker);

            return marker;
        }

        /**
         * initCustomMarker
         *
         * Creates a marker for custom POIs with category-specific icon
         *
         * @param   object markerData The marker data.
         * @param   object map The map instance.
         * @return  object The marker instance.
         */
        function initCustomMarker(markerData, map) {
            // Validate data
            if (!markerData.lat || !markerData.lng) {
                console.error('Invalid marker coordinates:', markerData);
                return null;
            }

            // Define icons for each category
            var icons = {
                ski_lift: {
                    url: '/wp-content/themes/alikats/assets/images/marker/ski-lift.svg',
                    scaledSize: new google.maps.Size(40, 40)
                },
                bus_stop: {
                    url: '/wp-content/themes/alikats/assets/images/marker/bus.svg',
                    scaledSize: new google.maps.Size(40, 40)
                },
                bar: {
                    url: '/wp-content/themes/alikats/assets/images/marker/bar.svg',
                    scaledSize: new google.maps.Size(40, 40)
                },
                restaurant: {
                    url: '/wp-content/themes/alikats/assets/images/marker/restaurant.svg',
                    scaledSize: new google.maps.Size(40, 40)
                },
                other: {
                    url: '/wp-content/themes/alikats/assets/images/marker/other.svg',
                    scaledSize: new google.maps.Size(40, 40)
                }
            };

            // Get the appropriate icon
            var icon = icons[markerData.type] || icons.other;

            // Create marker instance
            var marker = new google.maps.Marker({
                position: {
                    lat: parseFloat(markerData.lat),
                    lng: parseFloat(markerData.lng)
                },
                map: map,
                icon: icon,
                title: markerData.title || 'Location',
                category: markerData.type || 'other'
            });

            // Create info window content
            var infoWindowContent = '<div class="map-infowindow marker-infowindow">' +
                                   '<h4>' + (markerData.title || 'Location') + '</h4>';

            // Add link if available
            if (markerData.url) {
                infoWindowContent += '<a href="' + markerData.url + '" class="info-link">Learn More</a>';
            }

            infoWindowContent += '</div>';

            // Create info window
            var infoWindow = new google.maps.InfoWindow({
                content: infoWindowContent
            });

            // Show info window when marker is clicked
            google.maps.event.addListener(marker, 'click', function() {
                // Close all open info windows first
                map.markers.forEach(function(m) {
                    if (m.infoWindow) {
                        m.infoWindow.close();
                    }
                });

                infoWindow.open(map, marker);
            });

            // Store infoWindow reference
            marker.infoWindow = infoWindow;

            // Append to reference for later use
            map.markers.push(marker);

            return marker;
        }

        /**
         * centerMap
         *
         * Centers the map on chalet markers only (or inline markers without category).
         *
         * @param   object map The map instance.
         * @return  void
         */
        function centerMap(map) {
            // Create map boundaries from chalet/inline markers only
            var bounds = new google.maps.LatLngBounds();

            // Check if we have any markers
            if (!map.markers || map.markers.length === 0) {
                console.log('No markers to center map on');
                return;
            }

            // Only include chalet markers or markers without a category (inline markers)
            var centerMarkers = map.markers.filter(function(marker) {
                return !marker.category || marker.category === 'chalets';
            });

            if (centerMarkers.length === 0) {
                console.log('No chalet markers to center map on');
                return;
            }

            centerMarkers.forEach(function(marker) {
                if (marker.getPosition) {
                    bounds.extend(marker.getPosition());
                }
            });

            // Case: Single marker.
            if (centerMarkers.length == 1) {
                map.setCenter(bounds.getCenter());
                map.setZoom(16);
            // Case: Multiple markers.
            } else {
                map.fitBounds(bounds);
            }
        }
    }

    // Initialize when DOM is ready
    $(document).ready(function() {
        console.log('Document ready, checking Google Maps status...');

        // If Google Maps is already loaded, initialize immediately
        if (typeof google !== 'undefined' && google.maps) {
            console.log('Google Maps already loaded, initializing...');
            window.initializeGoogleMaps();
        } else {
            console.log('Waiting for Google Maps to load...');
        }
    });

})(jQuery);